module.exports = __webpack_public_path__ + "img/sonography.2f19eb7a.png";